import React, {useEffect} from 'react';
import './App.css';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import AccessDeniedPage from "./pages/AccessDeniedPage";
import MainPage from "./pages/MainPage";

import {AppManager, userSession$} from 'top-app-manager';
import 'top-app-manager/dist/index.css';
import config from './config/app-config.json';
import appConfig from "./config/apps.json";

const authConfig = {
    ...config,
    ...appConfig
};

function App() {
    const [session, setSession] = React.useState(null);
    useEffect(() => {
        userSession$.subscribe(session => setSession(session))
    }, [])
    return (
        <div className="App">
            <Router>
                <AppManager config={authConfig}/>
                {session ? (
                    <React.Fragment>
                        <Header showAvatar={true}/>
                        <Switch>
                            <Route path="/access-denied" component={AccessDeniedPage}/>
                            <Route path="/" component={MainPage}/>
                        </Switch>
                        <Footer/>
                    </React.Fragment>
                ) : null}
            </Router>
        </div>
    );
}

export default App;
